const MESSAGES = {
    REQUIRED_FIELD: 'This is a required field.',
    INVALID_EMAIL: 'Invalid email address.',
    INVALID_PHONE: 'Invalid phone number.',
};

export default MESSAGES;
